
export const Footer = () => {
    return <footer className="main__footer center__flex flex__dir-col">
        <h2 className="text-mid">Made with &lt;/&gt; By Ranjeet Singh</h2>
        <p>@ 2022 Jeetsdev</p>
    </footer>
}